// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

#custombutton img{
    width: 60px;
    /* background-color: white; */
    color: black;
}
.row{
    width: 100%  !important;
    
}
.col{
    padding: .2%;
}
#custombutton{
    background-color: #FCF0CC;

    width: 100px;
    height: 100px;
    border-radius: 30px;
    border: none;
    
}
.container{
    max-width: 100%;
}
#buttonDiv{
    word-wrap: break-word;
    white-space: pre-wrap;
   
    display: flex;
    align-content: center;
    align-items: center;
    flex-direction: column;
}

#buttonDiv p{
    font-size: 12px;
}

#custombutton:hover {
    color: black !important;
    background-color: white;


    box-shadow: 3px 5px 1px #FDDC79;
}

#custombutton.active{

    background-color: white;
  
    box-shadow: 3px 5px 1px #FDDC79;

}

#custombutton:first-child:active{

    background-color: white;
   
    
}
 

.col{
    /* height: 100px; */
}
#custombutton:first-child:active{

    background-color: white;

    border-color: transparent;box-shadow: 0px 5px #FDDC79;
}

@media only screen and (max-width: 767px) {
    .collobtn #buttonDiv{
        height: 70px ;
        overflow:hidden;
    }
    .col{
        padding: 0%;
        padding-bottom: 4%;
    }
    .container{
        min-width: 300px;
        max-width: 400px;
    }
    #custombutton{
        background-color: #FCF0CC;
        height: auto;
    }
}
@media only screen and (min-width: 768px) and (max-width: 1050px){
    .container{
        min-width: 400px;
        max-width: 630px;
    }    
    .collobtn #buttonDiv{
        height: 100px ;
        overflow:hidden;
    }
    #custombutton img{
        width: 60px;
        /* background-color: white; */
        color: black;
    }
    .row{
        width: 100%  !important;
        
    }
    .col{
        padding: .2%;
    }
    #custombutton{

        width: 100px;
        height: auto;
        border-radius: 30px;
        border: none;
        
    }

    
    #buttonDiv{
        word-wrap: break-word;
        white-space: pre-wrap;
       
        display: flex;
        align-content: center;
        align-items: center;
        flex-direction: column;
    }
    
    #buttonDiv p{
        font-size: 12px;
    }
    
    #custombutton:hover {
        color: black !important;
        background-color: white;
        border-color: red;
       
        box-shadow: 3px 5px 1px #FDDC79;
    }
    
    #custombutton.active{
       
        background-color: white;
        
    
    }
    
    #custombutton:first-child:active{
        
        background-color: white;
    
        border-color: transparent;box-shadow: 0px 5px #FDDC79;
    }
     
    
    .col{
        padding: 0%;
        padding-top: 2%;
    }
}
@media only screen and (min-width: 1050px) {
    #custombutton:first-child:active{
        height: 60px;
        
    }
    #buttonDiv{
        word-wrap: break-word;
        white-space: pre-wrap;
        align-items: baseline;
        display: flex;
        align-content: center;
        align-items: center;
        flex-direction: row;
    }
    #custombutton{
        background-color: #FCF0CC;
        width: 150px;
        height: auto;

        /* height: px; */
        border-radius: 30px;
        border: none;
        
    }
    .col{
        padding: 0%;
        padding-bottom: 2%;
    }
    #custombutton img{
        width: 30px !important;
        /* background-color: white; */
        color: black;
    }
    .custombutton:hover{
        height: -moz-fit-content !important;
        height: fit-content !important;
    }
    .custombutton.active{
        height: -moz-fit-content  !important;
        height: fit-content  !important;
    }
    #custombutton:hover{
       height: -moz-fit-content ;
       height: fit-content ;
    }
    #custombutton.active{
        color: red !important;
        background-color: white;
        border-color: red;
        height: -moz-fit-content ;
        height: fit-content ;
        box-shadow: 3px 5px 1px #FDDC79;
    
    }
    
    #custombutton p{
        display: flex;
        /* background-color: white; */
        justify-content: center;
        align-items: center;
        width: 50%;
        text-align: center;
    }
    .container{
        min-width: 400px;
        max-width: 630px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components__old/CustomButton/CustomButton.css"],"names":[],"mappings":";;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;AACA;IACI,uBAAuB;;AAE3B;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;;IAEzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;;AAEhB;AACA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,qBAAqB;;IAErB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;;;IAGvB,+BAA+B;AACnC;;AAEA;;IAEI,uBAAuB;;IAEvB,+BAA+B;;AAEnC;;AAEA;;IAEI,uBAAuB;;;AAG3B;;;AAGA;IACI,mBAAmB;AACvB;AACA;;IAEI,uBAAuB;;IAEvB,yBAAyB,CAAC,2BAA2B;AACzD;;AAEA;IACI;QACI,aAAa;QACb,eAAe;IACnB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,yBAAyB;QACzB,YAAY;IAChB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,eAAe;IACnB;IACA;QACI,WAAW;QACX,6BAA6B;QAC7B,YAAY;IAChB;IACA;QACI,uBAAuB;;IAE3B;IACA;QACI,YAAY;IAChB;IACA;;QAEI,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,YAAY;;IAEhB;;;IAGA;QACI,qBAAqB;QACrB,qBAAqB;;QAErB,aAAa;QACb,qBAAqB;QACrB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,iBAAiB;;QAEjB,+BAA+B;IACnC;;IAEA;;QAEI,uBAAuB;;;IAG3B;;IAEA;;QAEI,uBAAuB;;QAEvB,yBAAyB,CAAC,2BAA2B;IACzD;;;IAGA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;AACA;IACI;QACI,YAAY;;IAEhB;IACA;QACI,qBAAqB;QACrB,qBAAqB;QACrB,qBAAqB;QACrB,aAAa;QACb,qBAAqB;QACrB,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,yBAAyB;QACzB,YAAY;QACZ,YAAY;;QAEZ,gBAAgB;QAChB,mBAAmB;QACnB,YAAY;;IAEhB;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,6BAA6B;QAC7B,YAAY;IAChB;IACA;QACI,mCAA8B;QAA9B,8BAA8B;IAClC;IACA;QACI,oCAA+B;QAA/B,+BAA+B;IACnC;IACA;OACG,yBAAoB;OAApB,oBAAoB;IACvB;IACA;QACI,qBAAqB;QACrB,uBAAuB;QACvB,iBAAiB;QACjB,yBAAoB;QAApB,oBAAoB;QACpB,+BAA+B;;IAEnC;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ","sourcesContent":["\n\n#custombutton img{\n    width: 60px;\n    /* background-color: white; */\n    color: black;\n}\n.row{\n    width: 100%  !important;\n    \n}\n.col{\n    padding: .2%;\n}\n#custombutton{\n    background-color: #FCF0CC;\n\n    width: 100px;\n    height: 100px;\n    border-radius: 30px;\n    border: none;\n    \n}\n.container{\n    max-width: 100%;\n}\n#buttonDiv{\n    word-wrap: break-word;\n    white-space: pre-wrap;\n   \n    display: flex;\n    align-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n#buttonDiv p{\n    font-size: 12px;\n}\n\n#custombutton:hover {\n    color: black !important;\n    background-color: white;\n\n\n    box-shadow: 3px 5px 1px #FDDC79;\n}\n\n#custombutton.active{\n\n    background-color: white;\n  \n    box-shadow: 3px 5px 1px #FDDC79;\n\n}\n\n#custombutton:first-child:active{\n\n    background-color: white;\n   \n    \n}\n \n\n.col{\n    /* height: 100px; */\n}\n#custombutton:first-child:active{\n\n    background-color: white;\n\n    border-color: transparent;box-shadow: 0px 5px #FDDC79;\n}\n\n@media only screen and (max-width: 767px) {\n    .collobtn #buttonDiv{\n        height: 70px ;\n        overflow:hidden;\n    }\n    .col{\n        padding: 0%;\n        padding-bottom: 4%;\n    }\n    .container{\n        min-width: 300px;\n        max-width: 400px;\n    }\n    #custombutton{\n        background-color: #FCF0CC;\n        height: auto;\n    }\n}\n@media only screen and (min-width: 768px) and (max-width: 1050px){\n    .container{\n        min-width: 400px;\n        max-width: 630px;\n    }    \n    .collobtn #buttonDiv{\n        height: 100px ;\n        overflow:hidden;\n    }\n    #custombutton img{\n        width: 60px;\n        /* background-color: white; */\n        color: black;\n    }\n    .row{\n        width: 100%  !important;\n        \n    }\n    .col{\n        padding: .2%;\n    }\n    #custombutton{\n\n        width: 100px;\n        height: auto;\n        border-radius: 30px;\n        border: none;\n        \n    }\n\n    \n    #buttonDiv{\n        word-wrap: break-word;\n        white-space: pre-wrap;\n       \n        display: flex;\n        align-content: center;\n        align-items: center;\n        flex-direction: column;\n    }\n    \n    #buttonDiv p{\n        font-size: 12px;\n    }\n    \n    #custombutton:hover {\n        color: black !important;\n        background-color: white;\n        border-color: red;\n       \n        box-shadow: 3px 5px 1px #FDDC79;\n    }\n    \n    #custombutton.active{\n       \n        background-color: white;\n        \n    \n    }\n    \n    #custombutton:first-child:active{\n        \n        background-color: white;\n    \n        border-color: transparent;box-shadow: 0px 5px #FDDC79;\n    }\n     \n    \n    .col{\n        padding: 0%;\n        padding-top: 2%;\n    }\n}\n@media only screen and (min-width: 1050px) {\n    #custombutton:first-child:active{\n        height: 60px;\n        \n    }\n    #buttonDiv{\n        word-wrap: break-word;\n        white-space: pre-wrap;\n        align-items: baseline;\n        display: flex;\n        align-content: center;\n        align-items: center;\n        flex-direction: row;\n    }\n    #custombutton{\n        background-color: #FCF0CC;\n        width: 150px;\n        height: auto;\n\n        /* height: px; */\n        border-radius: 30px;\n        border: none;\n        \n    }\n    .col{\n        padding: 0%;\n        padding-bottom: 2%;\n    }\n    #custombutton img{\n        width: 30px !important;\n        /* background-color: white; */\n        color: black;\n    }\n    .custombutton:hover{\n        height: fit-content !important;\n    }\n    .custombutton.active{\n        height: fit-content  !important;\n    }\n    #custombutton:hover{\n       height: fit-content ;\n    }\n    #custombutton.active{\n        color: red !important;\n        background-color: white;\n        border-color: red;\n        height: fit-content ;\n        box-shadow: 3px 5px 1px #FDDC79;\n    \n    }\n    \n    #custombutton p{\n        display: flex;\n        /* background-color: white; */\n        justify-content: center;\n        align-items: center;\n        width: 50%;\n        text-align: center;\n    }\n    .container{\n        min-width: 400px;\n        max-width: 630px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
